// extracted by mini-css-extract-plugin
export var wrapper = "CookiesPolicy-module--wrapper--f291d";
export var hidden = "CookiesPolicy-module--hidden--10292";
export var container = "CookiesPolicy-module--container--3ac2e";
export var contentWrapper = "CookiesPolicy-module--contentWrapper--c9ed1";
export var content = "CookiesPolicy-module--content--fecc7";
export var text = "CookiesPolicy-module--text--b12f9";
export var button = "CookiesPolicy-module--button--259ad";